import {
  Check,
  Circle,
  CircleCheck,
  Clock,
  Grid3x3,
  ShieldCheck,
  TriangleAlert,
  TrendingDown,
  Upload,
  type LucideIcon,
} from "lucide-react";
import type { PipelineStageId } from "@/lib/pipelineBoard";

/** Primary column-header icon per stage (matches 1-pipeline-board.html). */
export const PIPELINE_STAGE_ICONS: Record<PipelineStageId, LucideIcon> = {
  upload: Upload,
  map: Grid3x3,
  validate: ShieldCheck,
  resolve: TriangleAlert,
  published: CircleCheck,
};

/** Small subtitle accent icon per stage (matches col-sub in the HTML mock). */
export const PIPELINE_STAGE_SUBTITLE_ICONS: Record<PipelineStageId, LucideIcon> = {
  upload: Clock,
  map: Grid3x3,
  validate: Circle,
  resolve: TrendingDown,
  published: Check,
};
